const ve = {
    CustomEvent: "ce",
    Pr: "p",
    Nl: "pc",
    cc: "ca",
    qa: "i",
    qs: "ie",
    T: "cci",
    W: "ccic",
    _: "ccc",
    L: "ccd",
    yh: "ss",
    wh: "se",
    Mi: "si",
    Ii: "sc",
    Ai: "sbc",
    Ze: "sfe",
    ro: "iec",
    Ml: "lr",
    Rl: "uae",
    U: "ci",
    F: "cc",
    Ul: "lcaa",
    Il: "lcar",
    Fn: "inc",
    Un: "add",
    En: "rem",
    Sn: "set",
    An: "ncam",
    xl: "sgu"
  },
  De = { qr: "feed_displayed", dc: "content_cards_displayed" };
export { ve as EventTypes, De as InternalEventTypes };
